export default function isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}



// WEBPACK FOOTER //
// ./node_modules/react-native-material-ui/src/utils/isFunction.js